import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'    
import { createPinia } from 'pinia'
import { createHead } from '@vueuse/head'

import 'vuetify/styles'
import '@mdi/font/css/materialdesignicons.css'

import axios from 'axios'
axios.defaults.baseURL = process.env.VUE_APP_BACK_URL
axios.defaults.withCredentials = true

const head = createHead()
const app = createApp(App);
app.use(head)

app.use(createPinia()); 
app.use(router);
app.use(vuetify);

router.isReady().then(() => {
  app.mount('#app')
})